module.exports = __webpack_public_path__ + "static/media/video2_photo.b5ed29c4.jpg";